import React, { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/pro-regular-svg-icons/faCircleCheck";
import { faCircleCheck as faCircleSolidCheck } from "@fortawesome/pro-solid-svg-icons/faCircleCheck";

export const CircleCheck: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faCircleCheck} {...props} />
);

export const SolidCircleCheck: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faCircleSolidCheck} {...props} />
);
